import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const useSessionTimeout = (timeoutMinutes = 15) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const resetTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      // Clear any stored tokens or session data
      localStorage.removeItem('11p221#');
      // Force navigation to login
      window.location.href = '/login';
    }, timeoutMinutes * 60 * 1000);
  }, [timeoutMinutes]);

  useEffect(() => {
    // Set up event listeners for user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    const handleUserActivity = () => {
      resetTimeout();
    };

    // Add event listeners
    events.forEach(event => {
      window.addEventListener(event, handleUserActivity);
    });

    // Initial timeout setup
    resetTimeout();

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, handleUserActivity);
      });
    };
  }, [resetTimeout]);

  return resetTimeout;
};

export default useSessionTimeout; 